export default "__VITE_ASSET__BRVPu7Dm__"